/* eslint-disable */
import {
  THEME_BREAKPOINT_LG_STEP,
  THEME_BREAKPOINT_MD_STEP,
  THEME_BREAKPOINT_SM_STEP,
  THEME_BREAKPOINT_XL_STEP,
  THEME_BREAKPOINT_XS_STEP,
} from '../../Constants/Theme/Theme.constants';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when a `step` is invalid
 * @export
 * @class ThemeInvalidWidthStepError
 * @extends {Error}
 */
export class ThemeInvalidWidthStepError extends Error {
  /**
   * Creates an instance of ThemeInvalidWidthStepError
   * @param {string} message The Error `message`
   * @memberof ThemeInvalidWidthStepError
   */
  constructor(message) {
    super(message);
    this.name = `ThemeInvalidWidthStepError`;
  }
}

/**
 * Called when a `step` is invalid
 * @param {any} step The invalid step
 * @returns {never} never
 */
const throwThemeInvalidWidthStepError = (step) => {
  throw new ThemeInvalidWidthStepError(
    stripIndent(`
    Expected "step" to be either
      "${THEME_BREAKPOINT_XS_STEP}
      "${THEME_BREAKPOINT_SM_STEP}
      "${THEME_BREAKPOINT_MD_STEP}
      "${THEME_BREAKPOINT_LG_STEP}
      "${THEME_BREAKPOINT_XL_STEP}
    Got: "${step}"
    `),
  );
};

export default throwThemeInvalidWidthStepError;
